import { create } from "zustand";
import { persist } from "zustand/middleware";
import axios from "axios";


const fetchData = async (url) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

const useDailyReportFilterStore = create(
  persist(
    (set, get) => ({
      filters: {
        employeeId: "",
        designationId: "",
        transferStationId: "",
        punchInLocation: "",
        punchOutLocation: "",
        jawaharNagar: true,
      },
      designations: [],
      locations: [],
      punchInLocations: [],
      punchOutLocations:[],
      loading: false,

      setFilter: (filterKey, value, ) => {
        set((state) => ({
          filters: { ...state.filters, [filterKey]: value },
        }));
      },

      setDesignations: (designations) => {
        set({ designations });
      },

      setLocations: (locations) => {
        set({ locations });
      },
      setPunchInLocation: (punchInLocations) => { // Added method for punch-in locations
        set({ punchInLocations });
      },
      setPunchOutLocation: (punchOutLocations) => { // Added method for punch-in locations
        set({ punchOutLocations });
      },
      resetFilters: () => {
        set({
          filters: {
            employeeId: "",
            designationId: "",
            transferStationId: "",
            punchInLocation: "",
            punchOutLocation: "",
            jawaharNagar: true,
          },
        });
      },
    }),
    { name: "daily-report-filters" }
  )
);


export default useDailyReportFilterStore;
